const APPOINTMENT_FIELDS = [
  'customer_id',
  'customer_name',
  'appointment_type_id',
  'job_type_id',
  'employee_id',
  'title',
  'description',
  'start_time',
  'end_time',
  'status',
  'notes',
  'service_street',
  'service_city',
  'service_state',
  'service_zip',
  'details',
  'estimate_on_file',
];

const RECURRENCE_FIELDS = [
  'anchor_date',
  'frequency',
  'count',
  'end_date',
];

const OVERRIDE_FIELDS = [
  'recurrence_sequence',
  'date',
  'start_time',
  'end_time',
  'employee_id',
];

const assertObject = (value, field) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    throw new TypeError(`${field} must be an object.`);
  }
};

const copyFields = (source, fields) => {
  const copy = {};
  fields.forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(source, field)) {
      copy[field] = source[field];
    }
  });
  return copy;
};

export const buildRecurringAppointmentPreviewPayload = ({
  appointment,
  recurrence,
  overrides,
} = {}) => {
  assertObject(appointment, 'appointment');
  assertObject(recurrence, 'recurrence');
  if (!Array.isArray(overrides)) {
    throw new TypeError('overrides must be an array.');
  }

  return {
    appointment: copyFields(appointment, APPOINTMENT_FIELDS),
    recurrence: copyFields(recurrence, RECURRENCE_FIELDS),
    overrides: overrides.map((override, index) => {
      assertObject(override, `overrides[${index}]`);
      return copyFields(override, OVERRIDE_FIELDS);
    }),
  };
};

export const buildRecurringAppointmentCreatePayload = ({
  previewPayload,
  recurrenceBatchId,
  previewToken,
} = {}) => {
  if (typeof recurrenceBatchId !== 'string' || !recurrenceBatchId.trim()) {
    throw new TypeError('recurrenceBatchId is required.');
  }
  if (typeof previewToken !== 'string' || !previewToken.trim()) {
    throw new TypeError('previewToken is required.');
  }

  const payload = buildRecurringAppointmentPreviewPayload(previewPayload);
  return {
    ...payload,
    recurrenceBatchId,
    previewToken,
  };
};
